import { motion } from "framer-motion";

const WhoWeWorkWithSection = () => {
  const audiences = [
    {
      title: "Propriétaires Forestiers Privés",
      description: "Valorisation, cession et structuration de patrimoines forestiers",
    },
    {
      title: "Héritiers & Familles",
      description: "Accompagnement dans la succession et la transmission",
    },
    {
      title: "Investisseurs Long Terme",
      description: "Diversification en actifs réels",
    },
    {
      title: "Capitaux Institutionnels",
      description: "La forêt comme investissement durable",
    },
    {
      title: "Acteurs Locaux",
      description: "Notaires, communes, coopératives",
    },
  ];

  return (
    <section
      id="who-we-help"
      data-testid="who-we-help-section"
      className="py-24 md:py-32 bg-forest text-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <p className="text-xs uppercase tracking-[0.2em] text-gold font-sans font-semibold mb-4">
            Nos Clients
          </p>
          <h2
            className="font-serif text-3xl md:text-4xl lg:text-5xl font-normal tracking-tight"
            data-testid="who-we-help-headline"
          >
            Avec Qui Nous Travaillons
          </h2>
        </motion.div>

        <div className="flex flex-wrap justify-center gap-6">
          {audiences.map((audience, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-white/10 backdrop-blur-sm px-8 py-6 text-center"
              data-testid={`audience-${index}`}
            >
              <h3 className="font-serif text-lg text-white mb-2">
                {audience.title}
              </h3>
              <p className="font-sans text-sm text-white/70">
                {audience.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoWeWorkWithSection;
